export default "__VITE_PUBLIC_ASSET__64d25eb1__"